/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import groupBy from 'lodash/groupBy';

import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type {
	CategorizedGroupData,
	PriorityGroup,
	QueueId,
} from './CategorizedQueueData.types.tsx';

type GroupResponse = PriorityGroup & {
	queueIds: QueueId[];
	category: string;
};

type GroupFetchResponse = {
	results: GroupResponse[];
};

const fetchGroupByKeyViaJira = async (projectKey: string, projectId: number | undefined | null) => {
	const queryParams = projectId ? `projectId=${projectId}` : `projectKey=${projectKey}`;
	return fetchJson(
		`/rest/servicedesk/latest/servicedesk/queue-group/groups?${queryParams}&operation=fetchPriorityGroups`,
	);
};

export const getPriorityGroupDataByProjectId = async (
	projectId: number | undefined | null,
	projectKey: string,
): Promise<CategorizedGroupData> => {
	const data: GroupFetchResponse = await fetchGroupByKeyViaJira(projectKey, projectId);

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const processedData = groupBy(
		data.results.map((group) => ({ ...group, queues: group.queueIds || [] })),
		'category',
	) as unknown;

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return processedData as CategorizedGroupData;
};
